import { black, producing } from "../../../../../constants/colors";
import BiAxialMultiShiftBarChart from "../../../../../components/Reports/GenericCharts/BiAxialMultiShiftBarChart";
import {
  PAGE_WIDTH_FOR_PRINT_PCI,
  RECHARTS_PRINT_WIDTH,
} from "../../../../../constants/constants";
import { Legend } from "recharts";
import { round } from "lodash";
import { PciChartProps } from "reports/types";

const bars = [
  {
    key: "netOutput",
    name: "Production Count",
    fill: black,
    label: true,
    yAxisId: "left",
  },
  {
    key: "oeePercent",
    name: "OEE Percent",
    fill: producing,
    label: true,
    yAxisId: "right",
  },
];

const lines = [];

const title = "Units and OEE by Shift";
/**
 * generate and create bar chart based on given data
 */
export default function ProductionOeeChart({
  data,
  width,
  height,
  oeeTarget,
}: PciChartProps) {
  const line2References = [
    { label: oeeTarget + "%", yValue: oeeTarget ? oeeTarget : null },
  ];

  // line1 is placeholder for now, will be used for targets later
  const line1References = [{}];

  const { weekTotalTarget, weekTotalOutput } = data
    ? data.reduce(
        (acc, { targetOutput, netOutput }) => {
          acc.weekTotalOutput = netOutput
            ? acc.weekTotalOutput + netOutput
            : acc.weekTotalOutput;

          acc.weekTotalTarget = targetOutput
            ? acc.weekTotalTarget + targetOutput
            : acc.weekTotalTarget;

          return acc;
        },
        {
          weekTotalTarget: 0,
          weekTotalOutput: 0,
        }
      )
    : { weekTotalTarget: 0, weekTotalOutput: 0 };

  const weekOee =
    weekTotalOutput && weekTotalTarget
      ? round((weekTotalOutput / weekTotalTarget) * 100, 2)
      : 0;

  const renderLegend = props => {
    const { payload } = props;
    const svgRect = (color: string) => {
      return (
        <svg width="12" height="12" style={{ marginRight: "5px" }}>
          <rect width="12" height="12" style={{ fill: color }} />
        </svg>
      );
    };
    return (
      <div style={{ display: "grid", gridTemplateRows: "1fr 1fr" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {payload.map((entry, index) => (
            <div
              style={{
                paddingRight: "10px",
                display: "flex",
                alignItems: "center",
              }}
              key={`item-${index}`}
            >
              {svgRect(entry.color)}
              {entry.value}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          Weekly Overall OEE: {weekOee}%
        </div>
      </div>
    );
  };

  return (
    <BiAxialMultiShiftBarChart
      title={title}
      data={data}
      xLabel={""}
      yLabel={"Units Processed (1000s)"}
      y2Label={"OEE Percentage %"}
      bars={bars}
      lines={lines}
      width={width}
      height={height}
      line2References={line2References}
      line1References={line1References}
      legend={
        <Legend
          key={title + ": legend"}
          width={
            width === PAGE_WIDTH_FOR_PRINT_PCI ? RECHARTS_PRINT_WIDTH : width
          }
          wrapperStyle={{
            top: 0,
            left: -55,
          }} /** this makes the legend not collide with the bars */
          verticalAlign="top"
          content={renderLegend}
        />
      }
    />
  );
}
